export default "__VITE_ASSET__539ac255__"